import moment from 'moment'
import getReadableLabel from './getReadableLabel'

const fields = [
  {
    value : 'eventId',
    label : 'Event ID',
  },
  {
    value : item => ( item?.state ? 'Acknowledged' : 'Active' ),
    label : 'State',
  },
  {
    value : item => getReadableLabel( item.type ),
    label : 'Type',
  },
  {
    value : item => getReadableLabel( item?.category ),
    label : 'Category',
  },
  {
    value : 'location',
    label : 'Location',
  },
  {
    value : item => moment( item.scanTime ).format( 'M/D HH:mm a' ),
    label : 'Scan Time',
  },
]

export default fields
